import { gettext } from "modules/django-i18n";

function _(translationKey) {
    return gettext(translationKey);
}

export default _;
